<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">评标报告</h2>
            </div>
            <div style="display: flex; gap: 12px;">
                 <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加评标报告</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>

            </div>
        </div>
        <div class="table-section">
            <!-- 数据表格 -->
            <el-table :data="tableData" v-loading="loading" class="report-table" stripe border>
                <el-table-column prop="no" label="NO." width="80" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="bidSectionName" label="标段名称" align="left" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="bidSectionCode" label="标段编号" align="left">
                </el-table-column>
                <el-table-column prop="noticeName" label="评标报告标题" align="left" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status == 0 ? 'info' : 'success'" size="small">
                            {{ scope.row.status == 0 ? '暂存' : '提交' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="详细信息" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status == 0">
                            <el-button type="text" size="small" @click="handleEdit(scope.row)" class="detail-btn">
                                编辑
                            </el-button>
                            <el-button type="text" size="small" @click="handleDelete(scope.row)" class="detail-btn" style="color: #f56c6c;">
                                删除
                            </el-button>
                        </template>
                        <template v-else>
                            <el-button type="text" size="small" @click="handleViewDetail(scope.row)" class="detail-btn">
                                查看详情
                            </el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <div class="pagination-section">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/bid/projectInfo'
import { evaluationReportDataList,deleteEvaluationReport,evaluationReportSubmit } from '@/api/modules/evaluationReport'

export default {
    name: 'EvaluationReport',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            loading: false,
            tableData: [],
            pageNum: 1,
            pageSize: 10,
            total: 0, // 总记录数
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        // 加载数据
        loadData() {
            this.loading = true;
            this.getProjectInfo();
            this.evaluationReportDataList()
        },
        async evaluationReportDataList() {
            try {
                const res = await evaluationReportDataList({
                    projectCode: this.projectCode,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize

                })
                if (res.code === 200) {
                    this.tableData = res.data.records;
                    this.total = res.data.total; // 总记录数
                    this.pageSize = res.data.size; // 每页大小
                    this.pageNum = res.data.current; // 当前页码
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                this.$message.error("获取项目详情失败")
            }
            setTimeout(() => {
                this.loading = false;
            }, 500);

        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 添加评标报告
        handleAdd() {
            this.$router.push('/agentHome/addEvaluationReport?projectCode=' + this.projectCode);
        },
        // 查看详情（只读）
        handleViewDetail(row) {
            this.$router.push('/agentHome/addEvaluationReport?projectCode=' + this.projectCode + '&bidEvaluationReportGuid=' + row.bidEvaluationReportGuid + '&mode=view');
        },
        // 编辑（暂存状态）
        handleEdit(row) {
            this.$router.push('/agentHome/addEvaluationReport?projectCode=' + this.projectCode + '&bidEvaluationReportGuid=' + row.bidEvaluationReportGuid + '&mode=edit');
        },
        //删除
        handleDelete(row){
            this.$confirm('此操作将永久删除该评标报告, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteLoading = true;
                deleteEvaluationReport(row.bidEvaluationReportGuid).then(res => {
                    if(res.code == 200){
                        this.deleteLoading = false;
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.loadData();
                    }else{
                        this.deleteLoading = false;
                        this.$message.error(res.msg)
                    }
                })
             }).catch(() => { })
        },
        // 添加公示
        handleAddPublicity(row){
              evaluationReportSubmit(row.bidEvaluationReportGuid).then(res => {
                    if(res.code == 200){
                        console.log(res);
                        this.$message.success('提交成功')
                    }else{
                        this.$message.error(res.msg)
                    }
                })
        },
        //  获取标题
        async getProjectInfo() {
            this.projectTitle = await loadProjectDetail(this.projectCode);
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.pageNum = 1; // 重置为第一页
            this.loadData();
        },

        // 当前页码改变
        handleCurrentChange(val) {
            this.pageNum = val;
            this.loadData();
        },

    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

.content-wrap {
    margin-top: 20px;
}

.report-table {
    width: 100%;
}

.report-table .el-table__header {
    background-color: #fafafa;
}

.report-table .el-table__header th {
    background-color: #fafafa;
    color: #606266;
    font-weight: 600;
    border-bottom: 1px solid #e4e7ed;
}

.detail-btn {
    color: #1890ff;
    font-size: 14px;
}

/* 分页样式 */
.pagination-section {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}
</style>
